import { FETCH_DAILY_SLEEP_REPORT_DATA, FETCH_WEEKLY_SLEEP_REPORT_DATA } from './ActionTypes';

export function fetchDailySleepReport(payload) {
    return {
        type: FETCH_DAILY_SLEEP_REPORT_DATA,
        payload
    };
}

export function fetchWeeklySleepReport(payload) {
    return {
        type: FETCH_WEEKLY_SLEEP_REPORT_DATA,
        payload
    };
}
